
import { createTheme, colors } from '@mui/material';

// A custom theme for this app
const theme = createTheme({
    palette: {
        primary: {
            main: '#ff6c00',
        },
        secondary: {
            main: '#fafafa',
            dark: '#7e7d7d',
        },
        error: {
            main: colors.red.A400,
        },
        background: {
            default: '#fff',
        },
    },
});

export default theme;